import React from "react";
import { withNamespaces } from "react-i18next";
import { Button } from "../styles/Design";
import styled from 'styled-components';
import { theme } from "../../style";


const HeaderContainer = styled.div`
  width: 40%;
  @media only screen and (max-width: ${theme.breakpoint.tablet}) {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const TitleContainer = styled.div`
display:flex;
`;

const HeaderTitle = styled.span`
font-weight: 700;
  font-size: 36px;
  margin: 0 0.25rem;
  ${(props) =>
    props.type === "primary" && `color: ${props.theme.colors.primary};`}
  ${(props) =>
    props.type === "secondary" && `color: ${props.theme.colors.secondary};`}
  @media only screen and (max-width: ${theme.breakpoint.small}) {
    font-size: 26px;
    ${(props) =>
    props.type === "primary" && `color: ${props.theme.colors.white};`}
    ${(props) =>
    props.type === "secondary" && `color: ${props.theme.colors.secondary};`}
  }
`;
const SubtitleContainer = styled.div`

`;
const HeaderSubtitle = styled.p`
  font-weight: 500;
  font-size: 20px;
  color: ${theme.colors.primary};
  @media only screen and (max-width: ${theme.breakpoint.small}) {
    font-size: 16px;
    font-weight: 500;
    color: ${theme.colors.white};
    text-align: center;
  }
  `;

const ButtonsContainer = styled.div`
display:flex;
`;




const HeaderContent = ({ t }) => {
  return (
    <HeaderContainer>
      <TitleContainer>
        <HeaderTitle type="secondary">Totarjim</HeaderTitle>
        <HeaderTitle type="primary"> Platform</HeaderTitle>
      </TitleContainer>
      <SubtitleContainer>
        <HeaderSubtitle>
          The first professional platform at the level of the remote translation
        </HeaderSubtitle>
      </SubtitleContainer>
      <ButtonsContainer>
        <Button type="primary">Translator</Button>
        <Button type="outline">Client</Button>
      </ButtonsContainer>
    </HeaderContainer>
  );
};

export default withNamespaces()(HeaderContent);
